/* eslint-disable */
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import ServicesContextPropTypes from '../../Contexts/Services/Services.props';
import AuthEntityPropTypes from '../../Services/Auth/Auth.service.props';
import I18nEntityPropTypes from '../../Services/I18n/I18n.service.props';
import UserEntityPropTypes from '../../Services/User/User.service.props';
import authActionCreators from '../../State/Store/Auth/Auth.actions';
import propsActionCreatorsToPropTypes from '../../Support/Props/ActionCreatorKey/PropsActionCreatorsToPropTypes.support';

const LoadingPropTypes = {
  /**
   * The actions to be used by this component
   */
  actions: PropTypes.shape({
    ...propsActionCreatorsToPropTypes(authActionCreators),
  }).isRequired,

  /**
   * The current `auth` or `null`
   */
  auth: AuthEntityPropTypes.auth,

  /**
   * The remaining duration for the `accessToken`
   */
  authExpiry: AuthEntityPropTypes.authExpiry.isRequired,

  /**
   * The user's presence
   */
  authPresence: UserEntityPropTypes.userPresence.isRequired,

  /**
   * The `histroy` props from `react-router`
   */
  history: ReactRouterPropTypes.history.isRequired,

  /**
   * The `lang` to use
   */
  lang: I18nEntityPropTypes.lang.isRequired,

  /**
   * The `Persistor` from `redux-persist`
   */
  persistor: PropTypes.shape({
    dispatch: PropTypes.func.isRequired,
    flush: PropTypes.func.isRequired,
    getState: PropTypes.func.isRequired,
    pause: PropTypes.func.isRequired,
    persist: PropTypes.func.isRequired,
    purge: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired,
  }).isRequired,

  /**
   * The services to be used by the given entry
   */
  services: ServicesContextPropTypes.services.isRequired,
};

export default LoadingPropTypes;
